<template>
  <div class="container shadow no-select">
    <div class="logo-container">
      <div class="logo">
        <img :src="require(`@/assets/ula_logo.png`)">
      </div>
    </div>

    <div class="navbar-items-container">
      <div v-for="item in menuItems" :key="item.title">
        <div @click=redirect(item.link)
             class="menu-button-container"
             v-if="shouldShow(item)">
          <i class="icon" :class="item.icon"></i>
          <p class="menu-button-text" v-text="item.title"></p>
        </div>
      </div>
    </div>

    <div id="logoutButton" @click="showLogout = true" class="menu-button-container logout-button">
      <i class="fa fa-sign-out-alt icon"></i>
      <p class="menu-button-text">Изход</p>
    </div>

    <div id="confirmLogout" class="logout-confirm" v-if="showLogout">
      <p>Сигурне ли сте?</p>
      <Button class="logout-button-confirm" @click.native="logout()" :id="'yes'" :text="'Да'"></Button>
      <Button class="logout-button-confirm" @click.native="showLogout = false" :id="'no'" :text="'Не'"></Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import menuItems from "@/components/navbar/navbar.config";
import Button from "@/shared/components/button/Button";
import autorizationService from '@/services/authorization.service';
import redirectService from "@/services/redirect.service";

export default {
  name: "NavBar",
  components: {Button},
  mounted() {
    // hide dropdown on outside click
    window.addEventListener('click', (e) => {
      if (document.getElementById('confirmLogout')
          && !document.getElementById('confirmLogout').contains(e.target)
          && !document.getElementById('logoutButton').contains(e.target)) {
        this.showLogout = false;
      }
    })
  },
  created() {
  },
  data() {
    return {
      menuItems,
      showLogout: false
    };
  },
  methods: {
    logout() {
      autorizationService.logout()
          .then((response) => {
            this.showLogout = false;
            if (response.status === 200) {
              this.$store.commit('setUser', null);
              redirectService.redirectToLogin();
            }
          });
    },
    redirect(link) {
      if (this.$route.path !== link) {
        this.$router.push(link);
      }
    },
    shouldShow(item) {
      if (item.anyRole) {
        return this.user && item.anyRole.includes(this.user.role);
      }

      return true;
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
}
</script>

<style scoped>
.container {
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 150px;
  z-index: 20;
}

.menu-button-container {
  font-family: Arial, Helvetica, sans-serif;
  color: var(--dark-grey);
  height: fit-content;
  width: 100%;
  margin: auto;
  padding: 15px 0;
  display: inline-block;
  border: solid transparent;
  border-width: 0 1px;
  box-sizing: border-box;
}

.menu-button-container:hover {
  cursor: pointer;
  color: var(--primary-blue);
}

.menu-button-text {
  display: inline-block;
  width: 80%;
  margin: 10px 10% 0 10%;
  text-align: center;
  font-size: 18px;
}

.logout-button {
  border-top: 1px solid var(--light-grey);
  background-color: var(--lightest-grey);
  position: absolute;
  bottom: 0;
  left: 0;
}

.logout-button:hover {
  color: var(--red)
}

.icon {
  font-size: 28px;
  width: 100%;
  text-align: center;
}

.logout-confirm {
  position: absolute;
  bottom: 15px;
  left: 125px;
  height: 80px;
  width: 200px;
  z-index: 20;
  -webkit-box-shadow: 0 0px 5px 1px var(--shadow-color);
  -moz-box-shadow: 0 0px 5px 1px var(--shadow-color);
  box-shadow: 0 0px 5px 1px var(--shadow-color);
  background-color: #ffffff;
  padding: 15px;
  font-size: 24px;
  color: var(--grey);
}

.logout-confirm p {
  text-align: center;
}

.logout-button-confirm {
  width: 80px;
  height: 40px;
  float: left;
  margin: 10px;
  font-size: 20px;
}

.logo-container {
  width: 100%;
  height: fit-content;
  margin-bottom: 15px;
  background-color: var(--lightest-grey);
  border-bottom: 1px solid var(--light-grey);
}

.logo {
  margin: 0 auto;
  padding: 20px 0;
  width: fit-content;
}

.navbar-items-container {
  overflow-y: auto;
  position: absolute;
  left: 0;
  top: 95px;
  bottom: 95px;
}

img {
  width: auto;
  height: 38px;
}

</style>
